import api from "services/api";
import type { ContaFinanceiraFiltroApi } from "../types/extrato-financeiro.types";

export async function listarContasFinanceirasFinanceiro(): Promise<{
  data: ContaFinanceiraFiltroApi[] | null;
  status: number;
}> {
  const res = await api.get<ContaFinanceiraFiltroApi[]>(
    "/loja/financeiro/contas-financeiras",
  );
  return { data: res.data ?? null, status: res.status };
}
